import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';
import {
  ANY_FIELD_UPDATE,
  FORMFIELD_UPDATE,
  ANY_FIELD_REMOVE,
  CLONE_OBJECT,
  STATE_DETAIL_CHANGE,
  VALIDATE_BEGIN,
  VALIDATE_SUCCESS,
  VALIDATE_ERROR,
  addNestedFields,
  removeNestedFields,
  updatedObject,
  getObject,
} from 'actions/formActions';
import addKey from 'store/factories/addKey';
import { LOGOUT } from 'actions/loginStateActions';
import {
  INSPECTION_JOB_INIT,
  INSPECTION_JOB_SUBMIT_BEGIN,
  INSPECTION_JOB_SUBMIT_SUCCESS,
  INSPECTION_JOB_SUBMIT_FAIL,
  INSPECTION_JOB_UPLOAD_BEGIN,
  INSPECTION_JOB_UPLOAD_SUCCESS,
  INSPECTION_JOB_FETCH_BEGIN,
  INSPECTION_JOB_FETCH_SUCCESS,
  INSPECTION_JOB_FETCH_FAIL,
  INSPECTION_JOB_UPDATE_BEGIN,
  INSPECTION_JOB_UPDATE_SUCCESS,
  INSPECTION_JOB_UPDATE_FAIL,
  INSPECTION_JOB_RESET,
  INSPECTION_JOB_GET_LAB_LIST,
  // INSPECTION_INVOICES_FETCH_BEGIN,
  // INSPECTION_INVOICES_FETCH_SUCCESS,
  // INSPECTION_INVOICES_FETCH_FAIL,
} from './types';
import INITIAL_STATE from './state';

const getTabData = (inspectionInvoiceAddresses, inspectionFactory) => {
  const getRawInfo = (type) => inspectionInvoiceAddresses.find((e) => e.type === type);

  const supplier = getRawInfo('supplierInfo');
  const buyer = getRawInfo('buyerInfo');

  const factory = {
    name: inspectionFactory.name,
    nameChi: inspectionFactory.nameChi,
    address: inspectionFactory.address,
    addressChi: inspectionFactory.addressChi,
    country: inspectionFactory.country,
    city: inspectionFactory.city,
    contactPerson: inspectionFactory.contactPerson,
    contactPersonPhone: inspectionFactory.contactPersonPhone,
    contactPersonEmail: inspectionFactory.contactPersonEmail,
  };

  return {
    factory,
    supplier,
    buyer,
  };
};

export default function inspectionJobWorkspaceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case ANY_FIELD_UPDATE: {
      if (action.storeName !== 'inspectionJobWorkspace') return state;
      return {
        ...state,
        data: updatedObject(state.data, action.accessPath, action.newVal),
        isChanged: true,
      };
    }

    case STATE_DETAIL_CHANGE:
      if (action.storeName !== 'inspectionJobWorkspace') return state;
      return {
        ...state,
        [action.key]: action.newVal,
      };

    case VALIDATE_BEGIN:
      if (action.storeName !== 'inspectionJobWorkspace') return state;
      return {
        ...state,
        errors: [],
        status: 'validating',
      };

    case VALIDATE_SUCCESS:
      if (action.storeName !== 'inspectionJobWorkspace') return state;
      return {
        ...state,
        errors: INITIAL_STATE.errors,
        status: 'validated',
      };

    case VALIDATE_ERROR:
      if (action.storeName !== 'inspectionJobWorkspace') return state;
      return {
        ...state,
        errors: action.errors,
        status: 'failed',
      };

    case CLONE_OBJECT: {
      if (action.storeName !== 'inspectionJobWorkspace') return state;

      const cloneObject = Object.assign({}, getObject(state.data, action.accessPath, action.idx));
      delete cloneObject.id;
      const newObject = addNestedFields(state.data, action.accessPath, cloneObject);

      return {
        ...state,
        data: newObject,
      };
    }

    case ANY_FIELD_REMOVE: {
      if (action.storeName !== 'inspectionJobWorkspace') return state;

      const newObject = removeNestedFields(state.data, action.accessPath);

      return {
        ...state,
        data: newObject,
      };
    }

    case FORMFIELD_UPDATE: {
      if (action.storeName !== 'inspectionJobWorkspace') return state;

      return Object.assign({}, state, {
        data: {
          ...state.data,
          [action.fieldName]: action.newVal,
        },
        isChanged: true,
      });
    }

    case INSPECTION_JOB_INIT:
      return {
        ...INITIAL_STATE,
        status: 'editing',
      };

    case INSPECTION_JOB_SUBMIT_BEGIN:
      return {
        ...state,
        status: 'submitting',
      };

    case INSPECTION_JOB_SUBMIT_SUCCESS:
      return update(state, {
        data: {
          $merge: action.inspectionId,
        },
        status: {
          $set: 'success',
        },
      });

    case INSPECTION_JOB_SUBMIT_FAIL:
      return {
        ...state,
        status: 'failed',
        failReason: action.reason,
      };

    case INSPECTION_JOB_UPLOAD_BEGIN:
      return {
        ...state,
        status: 'uploading',
      };

    case INSPECTION_JOB_UPLOAD_SUCCESS:
      return {
        ...state,
        status: 'completed',
      };

    case INSPECTION_JOB_FETCH_BEGIN:
      return {
        ...state,
        status: 'fetching',
      };

    case INSPECTION_JOB_FETCH_SUCCESS:
      return update(state, {
        data: {
          $merge: {
            ...action.data,
            ...getTabData(action.data.inspectionInvoiceAddresses, action.data.inspectionFactory),
            inspectionQuotes: action.data.inspectionQuotes.map(addKey),
            inspectionServiceProviderMaps:
              action.data.inspectionServiceProviderMaps &&
              action.data.inspectionServiceProviderMaps.map((e) => ({
                label: e.serviceProvider.fullname,
                value: e.serviceProvider.id,
              })),
          },
        },
        status: {
          $set: 'editing',
        },
      });

    case INSPECTION_JOB_FETCH_FAIL:
      return {
        ...state,
        status: 'failed',
        failReason: action.reason,
      };

    // *********************************
    //      JOB UPDATE
    // *********************************
    case INSPECTION_JOB_UPDATE_BEGIN:
      return Object.assign({}, state, {
        status: 'updating',
      });

    case INSPECTION_JOB_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case INSPECTION_JOB_UPDATE_FAIL:
      return {
        ...state,
        status: 'failed',
        failReason: action.reason,
      };

    case INSPECTION_JOB_RESET:
    case LOGOUT:
      return INITIAL_STATE;

    //-------------------------------------------------
    // GET_LAB_LIST
    case INSPECTION_JOB_GET_LAB_LIST.LOADING:
      return {
        ...state,
        data: {
          ...state.data,
          labList: {
            ...state.data.labList,
            loading: true,
            error: null,
          },
        },
      };
    case INSPECTION_JOB_GET_LAB_LIST.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          labList: {
            loading: false,
            data: action.payload,
            error: null,
          },
        },
      };
    case INSPECTION_JOB_GET_LAB_LIST.ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          labList: {
            loading: false,
            data: [],
            error: action.payload,
          },
        },
      };
    default:
      return state;
  }
}
